import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import ViewOld from './view-old.tsx';
import View from './view.tsx';

export default componentWithCondition(() => fg('fix-date-picker-keyboard-a11y'), View, ViewOld);
